(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-collection-intro"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-ss-ci-toggle]');
    if (!button) return;
    const box = button.closest('[data-ss-ci]');
    const open = !box.classList.contains('is-open');
    box.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', String(open));
    button.querySelector('[data-ss-ci-more]').hidden = open;
    button.querySelector('[data-ss-ci-less]').hidden = !open;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-mengenrabatt"] && !Shopify.designMode) return;
  try {
    (() => {
    const update = (box) => {
      const scope = box.closest('.product-information, product-information, .product-details') || document;
      const input = scope.querySelector('input[name="quantity"]');
      const qty = Math.max(1, parseInt(input?.value, 10) || 1);
      const min1 = Number(box.dataset.min1);
      const min2 = Number(box.dataset.min2);
      const pct1 = box.dataset.pct1;
      const pct2 = box.dataset.pct2;
      const tier = qty >= min2 ? 2 : qty >= min1 ? 1 : 0;
      box.querySelectorAll('[data-tier]').forEach((li) => {
        li.classList.toggle('is-active', Number(li.dataset.tier) === tier);
      });
      const hint = box.querySelector('[data-ss-mr-hint]');
      if (!hint) return;
      if (tier === 2) hint.textContent = `−${pct2} % Mengenrabatt · wird im Warenkorb automatisch abgezogen`;
      else if (tier === 1) hint.textContent = `−${pct1} % Mengenrabatt · noch ${min2 - qty} Stück bis −${pct2} %`;
      else hint.textContent = `Noch ${min1 - qty} Stück bis −${pct1} % · wird im Warenkorb automatisch abgezogen`;
    };
    const updateAll = () => document.querySelectorAll('[data-ss-mr]').forEach(update);
    const isProductQty = (el) => el instanceof Element && !el.closest('cart-items-component, .cart-items');
    document.addEventListener('input', (e) => {
      if (isProductQty(e.target) && e.target.name === 'quantity') updateAll();
    });
    document.addEventListener('change', (e) => {
      if (isProductQty(e.target) && e.target.name === 'quantity') updateAll();
    });
    document.addEventListener('click', (e) => {
      if (isProductQty(e.target) && e.target.closest('quantity-selector-component, .quantity-selector')) {
        setTimeout(updateAll, 0);
      }
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll);
    else updateAll();
  })();
  } catch(e) { console.error(e); }
})();

})();
